<!--Warning Message-->
<div>
	<p>Fine records will be created for the selected group. This action cannot be edited or undone via group maintenance.</p>

	<p>Fines must be adjusted manually for each student in the group through the student fines menu item.</p>

	<p>Do you want to continue?</p>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onOk()">Yes</button>
	<button class="btn btn-primary" (click)="onCancel()">No</button>
</div>
